

import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class TransitionHeightCrossfade extends Vue {
  private containerHeight = 0;

  private enter(element: HTMLElement) {
    const size = element.clientHeight;

    (this.$el as HTMLElement).style.height = `${this.containerHeight}px`;

    requestAnimationFrame(() => {
      (this.$el as HTMLElement).style.height = `${size}px`;
    });
  }

  private afterEnter() {
    (this.$el as HTMLElement).style.height = '';
  }

  private beforeLeave(element: HTMLElement) {
    this.containerHeight = element.clientHeight;
  }
}
